/**
 * @deprecated : Theme should be defined within the THEMING_OVERRIDE setting
 * This file should be drop once we drop pharmaservices
 */
export default {
    pharmaservices: {
        primary: '#00A84E',
        secondary: '#4ac380',
        accent: '#badfbf',
        error: '#cc0a00',
        info: '#badfbf',
        success: '#006830',
        warning: '#ff8500',
        GTM: 'GTM-M78T652',
    },
    uniprix: {
        primary: '#0c4da2',
        secondary: '#ff8500',
        accent: '#7396c4',
        error: '#cc0a00',
        info: '#eaf4ff',
        success: '#4ea835',
        warning: '#ff8500',
        GTM: 'GTM-M78T652',
    },
    pharmaprix: {
        primary: '#45add6',
        secondary: '#66c8f2',
        accent: '#85e4ff',
        error: '#cc0a00',
        info: '#45add6',
        success: '#00799f',
        warning: '#ff8500',
        GTM: 'GTM-M78T652',
    },
    clicsante: {
        primary: '#00CCF2',
        secondary: '#0026F1',
        accent: '#6fa7fc',
        error: '#cc0a00',
        info: '#eaf4ff',
        success: '#033E5E',
        warning: '#ff8500',
        GTM: 'GTM-M78T652',
    },
    'reacts': {
        primary: '#7ABACA',
        secondary: '#4D93A3',
        accent: '#ABDAE5',
        error: '#cc0a00',
        info: '#FFEABA',
        success: '#00863E',
        warning: '#DF9449',
        GTM: 'GTM-M78T652',
    },
};

/**
 * To comply with https://www.cai.gouv.qc.ca/espace-evolutif-modernisation-lois/thematiques/mineurs/
 */
export const MIN_AGE_TO_BOOK_IN_APP = 14;

/**
 * Reference:
 * - src/components/metadata/inputs/RequesterLink/RequesterLink.vue
 * - src/lang/en|fr.js::appt.placeholder.requester_link_0|1
 */
export const APPOINTMENT_FOR_MYSELF = 0;
export const APPOINTMENT_FOR_SOMEONE_ELSE = 1;
